import React from 'react';
import YouTube from 'react-youtube';

const opts = {
  width: "100%",
  height: "100%", // fills the height of the container
  playerVars: {
    // https://developers.google.com/youtube/player_parameters
    autoplay: 1,
    // Hide player controls
    controls: 0,
    // Hide video info
    showinfo: 0,
    // Hide YouTube logo and title on player controls bar
    modestbranding: 1,
  }
};

const VideoPlayer = ({ videoId, windowWidth }) => {

  const onPlayerReady = (event) => {
    // access to player in all event handlers via event.target
    setTimeout(() => {
    event.target.pauseVideo();
  }, 1800); // pause after 1.8 seconds
  }



  return (
    <div 
      style={{
        position: "relative",
        width: `${windowWidth < 900 ? "40vw" : "20vw"}`,
        height: `${windowWidth < 900 ? "40vw" : "20vw"}`,
        maxHeight: "600px",
        maxWidth: "600px",
        overflow: "hidden", // hides the overflow of the width
        borderRadius: "50%",
        transform: "rotate(-135deg)", /* Cancel out the rotation of the circles */
      }}
    >
      <YouTube 
      iframeClassName="boosterVideoIframe" 
      videoId={videoId} 
      opts={opts} 
      onReady={onPlayerReady}
      />
    </div>
  );
};

export default VideoPlayer;
